/* JS for partials/awards.php */
jQuery(document).ready(function($) {
    $("#association-rack").slick({
        appendArrows: '.customNavigationAwards',
        autoplay: false,
        dots: false,
        slidesToShow: 7,
        infinite: true,
        initialSlide: 0,
        nextArrow: '<span class="icon icon-chevron-right"></span>',
        prevArrow: '<span class="icon icon-chevron-left"></span>',
        slidesToScroll: 4,
        variableWidth: false,
        //centerMode: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    //centerMode: true,
                    variableWidth: false,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    //centerMode: true,
                    variableWidth: false,
                }
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false,
                }
            }
        ]
    });
})